export default __webpack_public_path__ + "static/media/logo_GMX.17e8891c.svg";